
export default {
  data() {
    return {
      success: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$renderRecaptcha("feedback-recaptcha");
    });
  },
};
